<template>
  <div class="attachments-modal">
    <v-dialog
      v-model="isVisible"
      max-width="468"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="attachments-modal__title headline"
          primary-title
        >
          ATTACHMENTS
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <div class="attachments-modal__upload">
            <FileDragDrop v-model="files" @error="showErrors" />
          </div>
        </v-card-text>

        <v-card-actions class="attachments-modal__actions">
          <v-btn
            class="white--text"
            color="blue"
            medium
            :disabled="!files.length"
            :loading="isSubmitProcessing"
            @click="submitAttachments"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FileDragDrop from '@/components/FileDragDrop.vue';

export default {
  components: {
    FileDragDrop,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    attachments: {
      type: Array,
      required: true,
    },

    isSubmitProcessing: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      dragover: false,
      files: [],
    };
  },

  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible() {
      this.files = [];
    },
  },

  methods: {
    closeModal() {
      this.$emit('input', false);
    },

    submitAttachments() {
      this.$emit('addAttachments', this.files);
    },

    showErrors(errors) {
      this.$store.dispatch('showError', errors);
    },
  },
};
</script>

<style lang="scss" scoped>
.attachments-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 24px 24px;
  }

  &__row {
    margin-right: -8px;
    margin-left: -8px;
  }
  &__col {
    padding: 0 8px 12px;
  }

  &__upload {
    padding-bottom: 24px;
  }
}
</style>
